import {customEvent, fireChangeEvent} from "../../../../../webpack/modules/events";
import {initTomSelectQuantity} from "../../../../../webpack/modules-optimized/tomselect";

let initializedTomSelects = false;
customEvent('show.bs.offcanvas', '#product-page .options[data-option-type="multiple-selectable"][data-type="size"]', false, function(element) {
    if (!initializedTomSelects) {
        initTomSelectQuantities();
        initializedTomSelects = true;
    }
});

function initTomSelectQuantities()
{
    document.querySelectorAll('#product-page .options[data-option-type="multiple-selectable"] .select-quantity').forEach(function(quantity) {
        let tomSelect = initTomSelectQuantity(quantity);

        tomSelect.on('dropdown_close', function() {
            let wrapper = tomSelect.wrapper;
            let size = wrapper.closest('.size');
            let input = document.querySelector(`input[name="size"][id="${size.htmlFor}"]`);
            let quantity = tomSelect.getValue();

            if (!input) return;

            input.checked = quantity > 0;
            input.dataset.quantity = quantity;
            fireChangeEvent(input);
        });
    });
}